import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import classNames from 'classnames';

import styles from './site.module.css';

const VideoShowcase = ({ miniHeading, bigHeading, desc, content, defaultSrc, defaultPoster, videoOnLeft }) => {
  const pipVideo = useRef(null);
  const creativeStudioTarget = useRef(null);

  let observer = null;
  let currentcreativeStudioTarget = null;

  const [activeCreativeStudioVideo, setActiveCreativeStudioVideo] = useState(null);

  const playCreativeVideo = ({ src, activeButton }) => {
    pipVideo.current.src = src;
    pipVideo.current.play();
    setActiveCreativeStudioVideo(activeButton);
  };

  const handleCreativeStudioIntersection = (entries) => {
    if (activeCreativeStudioVideo) {
      return;
    }

    entries.map((entry) => {
      if (entry.isIntersecting) {
        setActiveCreativeStudioVideo('pip');
        pipVideo.current.play();

        observer.unobserve(currentcreativeStudioTarget);
      }

      return null;
    });
  };

  const nav = () => {
    return (
      <>
        <div className={styles.videoShowcaseDesc}>{desc}</div>
        <div>
          {content.map(({ id, src, icon, buttonText }) => {
            return (
              <Button
                key={id}
                className={classNames({
                  [styles.active]: activeCreativeStudioVideo === id,
                })}
                variant="contained"
                disableElevation
                onClick={() =>
                  playCreativeVideo({
                    src,
                    activeButton: id,
                  })
                }
              >
                {icon}
                <div className="text">{buttonText}</div>
              </Button>
            );
          })}
        </div>
      </>
    );
  };

  const video = () => {
    return (
      <video
        className={classNames({ [styles.videoOnLeft]: videoOnLeft })}
        ref={pipVideo}
        src={defaultSrc}
        width="100%"
        height="100%"
        loop
        muted
        poster={defaultPoster}
        playsInline
      />
    );
  };

  useEffect(() => {
    currentcreativeStudioTarget = creativeStudioTarget.current;

    observer = new IntersectionObserver(handleCreativeStudioIntersection, { threshold: 0.5 });
    observer.observe(currentcreativeStudioTarget);

    return () => {
      observer.unobserve(currentcreativeStudioTarget);
    };
  }, []);

  return (
    <div>
      <div className={styles.videoShowcaseMiniHeading}>{miniHeading}</div>
      <h2 className={styles.h2}>{bigHeading}</h2>
      <div className={styles.videoShowcase} ref={creativeStudioTarget}>
        <div className={styles.videoShowcaseBlock}>{videoOnLeft ? video() : nav()}</div>
        <div className={styles.videoShowcaseBlock}>{videoOnLeft ? nav() : video()}</div>
      </div>
    </div>
  );
};

VideoShowcase.defaultProps = {
  miniHeading: 'Creative Studio',
  bigHeading: 'Get creative.',
  desc: 'Build assets for a captivated audience.',
  videoOnLeft: false,
  defaultPoster: null,
};

VideoShowcase.propTypes = {
  miniHeading: PropTypes.string,
  bigHeading: PropTypes.string,
  desc: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      src: PropTypes.string,
      icon: PropTypes.element,
      buttonText: PropTypes.element,
    })
  ).isRequired,
  defaultSrc: PropTypes.string.isRequired,
  defaultPoster: PropTypes.string,
  videoOnLeft: PropTypes.bool,
};

export default VideoShowcase;
